import type { IDay } from "Types/day";

export const CEDARMAP_TOKEN: string = "c7c5dc6a741da52a0857f023224b989a41140cd1";

// export const MAP_CENTER = { lat: 32.64674557848894, lng: 51.67777329888067 };
export const MAP_CENTER = { lat: 35.7219, lng: 51.3347 };

export const DAYS: IDay[] = [
  { id: 1, name: "شنبه" },
  { id: 2, name: "یکشنبه" },
  { id: 3, name: "دوشنبه" },
  { id: 4, name: "سه‌شنبه" },
  { id: 5, name: "چهارشنبه" },
  { id: 6, name: "پنجشنبه" },
  { id: 7, name: "جمعه" },
];

export const BRIEFDAYS: IDay[] = [
  { id: 1, name: "ش" },
  { id: 2, name: "ی" },
  { id: 3, name: "د" },
  { id: 4, name: "س" },
  { id: 5, name: "چ" },
  { id: 6, name: "پ" },
  { id: 7, name: "ج" },
];

export const PROVINCES = [
  { name: "تهران", zoneId: 29 },
  { name: "اصفهان", zoneId: 7 },
];

export const MAP_CENTERS = [
  {},
  {},
  {},
  {},
  {},
  {},
  { lat: 32.64674557848894, lng: 51.67777329888067 },
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  { lat: 35.7219, lng: 51.3347 },
];
